var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 35 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(1.36876 0 0 1.04526 .359 .245)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-0.262 -0.235H25.309V15.072000000000001H-0.262z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.262 -0.235H25.309V15.072000000000001H-0.262z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-1",
    fill: "#AD3521",
    fillRule: "nonzero",
    d: "M1027.9 692.258l-5-5.156a.325.325 0 00-.47 0 .352.352 0 000 .486l4.43 4.569h-14.53c-.18 0-.33.154-.33.344 0 .19.15.343.33.343h14.53l-4.43 4.569a.352.352 0 000 .486c.07.067.15.101.24.101.08 0 .17-.034.23-.101l5-5.155a.352.352 0 000-.486z",
    transform: "matrix(-.7306 0 0 .9567 750.784 -654.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    fill: "#fff",
    fillRule: "nonzero",
    d: "M1027.9 692.258l-5-5.156a.325.325 0 00-.47 0 .352.352 0 000 .486l4.43 4.569h-14.53c-.18 0-.33.154-.33.344 0 .19.15.343.33.343h14.53l-4.43 4.569a.352.352 0 000 .486c.07.067.15.101.24.101.08 0 .17-.034.23-.101l5-5.155a.352.352 0 000-.486z",
    transform: "matrix(-.7306 0 0 .9567 764.698 -654.816)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.03f02b0d9f52e41b67c35ac9b07ee1ab.svg";
export { ForwardRef as ReactComponent };